import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { local } from 'next/lib/storage';
import OpenInBuilderModal from './OpenInBuilderModal';

const STORAGE_KEY = 'appcues:open-in-builder';

export const OpenInBuilderManager = ({
  onClose,
  onNavigate,
  type,
  visible,
  ...unhandledProps
}) => {
  const dismissed = !!local.get(`${STORAGE_KEY}:${type}`);

  useEffect(() => {
    if (dismissed && visible) {
      onNavigate();
    }
  }, [dismissed, onNavigate, visible]);

  const handleSave = checked => {
    local.set(`${STORAGE_KEY}:${type}`, checked);
    onNavigate();
    onClose();
  };

  return (
    <OpenInBuilderModal
      onClose={onClose}
      onSave={handleSave}
      type={type}
      visible={!dismissed && visible}
      {...unhandledProps}
    />
  );
};

OpenInBuilderManager.propTypes = {
  onClose: PropTypes.func,
  onNavigate: PropTypes.func,
  type: PropTypes.oneOf(['flows', 'pins', 'mobile']),
  visible: PropTypes.bool,
};

export default OpenInBuilderManager;
